import React from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';

import { Icon } from '@iconify/react';
import homeTwotone from '@iconify/icons-ant-design/home-twotone';
import imageIcon from '@iconify/icons-mi/image';
import deliveryIcon from '@iconify/icons-icon-park-outline/delivery';
import outlineSettings from '@iconify/icons-ic/outline-settings';

import SignOutButton from '../SignOut';
import * as ROUTES from '../../constants/routes';
import {Home, Image, Settings, LocalPostOffice, ExpandMore, AdminPanelSettings, Slideshow} from '@mui/icons-material';
import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material';
import './styles.css';
import { styled } from '@mui/styles';
import { withAuthorization, useProfile } from '../Session';
import { DATA_MODEL } from '../Firebase';
import FormDialog from '../common/FormDialog';
import ExternalPreviewButton from '../ExternalPreview';
import { canCreateProject, createProject, demoPath, watchDemos, watchProjects } from '../../services';


const NavigationApp = (props) => {
  const profile = useProfile();
  const history = useHistory();
  const location = useLocation();
  const [newProjectOpen, setNewProjectOpen] = React.useState(false);
  const [isSelected, setSelected] = React.useState([false, false, false, false, false, false]);
  const [projectsList, setProjectsList] = React.useState({});
  const [projectListSelection, setProjectListSelection] = React.useState([]);
  const [demos, setDemos] = React.useState([]);  // échantillons de démonstration (v2), lisibles par tous les comptes

  const handleListElementStyle = (index) => {
    if (isSelected[index]) {
      return;
    }
    let newSelected = [false, false, false, false, false, false];
    newSelected[index] = !isSelected[index]
    setSelected(newSelected);
    setProjectListSelection(Array(Object.keys(projectsList).length).fill(false))
  };

  const handleProjectListElementStyle = (index) => {
    if (projectListSelection[index]) {
      return;
    }
    let newSelected = Array(Object.keys(projectsList).length).fill(false);
    newSelected[index] = !newSelected[index]
    setProjectListSelection(newSelected);
    setSelected(Array(6).fill(false))
  }

  // Modèle v2 (preprod, émulateurs) : projets visibles selon le rôle, mis à jour en direct.
  React.useEffect(() => {
    if (DATA_MODEL !== 'v2' || !profile) return undefined;
    return watchProjects(profile, list => {
      setProjectsList(Object.fromEntries(list.map(p => [p.id, p.name])));
      setProjectListSelection(Array(list.length).fill(false));
    }, err => console.warn('Projects unavailable:', err.code || err.message));
  }, [profile?.uid, profile?.role]);

  React.useEffect(() => {
    if (DATA_MODEL !== 'v2' || !profile) return undefined;
    return watchDemos(setDemos, err => console.warn('Demos unavailable:', err.code || err.message));
  }, [profile?.uid]);

  // Modèle v1 (production).
  React.useEffect(() => {
    if (DATA_MODEL !== 'v1') return;
    props.firebase.Projects().where('owner_id', '==', props.firebase.auth.currentUser.uid).orderBy('last_update').get()
    .then((projects) => {
      var projectsList = {}
      var projectListSelectionInit = []
      projects.forEach(element => {
        projectsList[element.id] = element.data().name
        projectListSelectionInit.push(false)
      });
      setProjectsList(projectsList)
      setProjectListSelection(projectListSelectionInit)
    })
    .catch(err => console.warn('Projects unavailable:', err.code || err.message))
    }
    , []);

  return (
    <div id = 'navigation-app-bar'>
      <img id = 'logo-navigation-app-bar'  src = {"https://hyprview-landing-images.s3.eu-west-3.amazonaws.com/logo_hyprview_thin.png"} alt = ''/>
      {DATA_MODEL === 'v2' && <div className='navigation-preview'><ExternalPreviewButton /></div>}
      <div id = 'navigation-app-list'>
        <div className='navigation-list-element-container' onClick={() => {handleListElementStyle(0); document.title = 'Home'}}
          style = { isSelected[0] ? {backgroundColor:'rgb(40,40,40)'}:{}}
        >
          <Link style = {isSelected[0] ? {cursor:'default'} : {cursor:'pointer'}} className = 'link-navigation-app-bar' to={ROUTES.HOME}> 
            <Home className = 'navigation-app-icon' />
            <p>Home</p>
          </Link>
        </div>
        <div >
          <Accordion disableGutters sx = {{width: '250px', backgroundColor: 'black'}}>
            <AccordionSummary 
              expandIcon={<ExpandMore style = {{color:'white'}} />}
              sx = {{
                '& .MuiAccordionSummary-content': {
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  height: '40px',
                  margin:'0px',
                },
                backgroundColor: 'black',
                color: 'white',
                padding: '0px',
                border: '0px',
                boxShadow: 'none',
                paddingRight: '5px',
                '&:hover': {
                  backgroundColor: 'rgb(40, 40, 40)',
                },

              }}
            >
              <Image className = 'navigation-app-icon' />
              <p style = {{ fontSize:'14px', margin:'0px', marginLeft:'10px', height:'16px'}}>Projects</p>
            </AccordionSummary>
            <AccordionDetails sx = {{padding:'0px'}}>
                {Object.keys(projectsList).map((projectId, index) => {
                  // v2 : surbrillance selon la page affichée (la liste se réordonne quand un projet est créé)
                  const projectPath = ROUTES.FILE_BROWSER + '/' + projectId;
                  const selected = DATA_MODEL === 'v2'
                    ? location.pathname === projectPath || location.pathname.startsWith(projectPath + '/')
                    : projectListSelection[index];
                  return (
                    <Link key = {projectId} style = {selected ? {cursor:'default'} : {cursor:'pointer', textDecoration:'none'}} to={ROUTES.FILE_BROWSER + '/' + projectId}>
                      <div className = 'project-list-element-container' key = {projectId} style = {selected ? {backgroundColor:'rgb(40,40,40)'} : {}} onClick={() => handleProjectListElementStyle(index)}>
                        <p key = {projectId} style = {{ fontSize:'14px', margin:'0px', marginLeft:'10px', color:'white'}}>{projectsList[projectId]}</p>
                      </div>
                    </Link>
                  )
                  }
                )}
                {DATA_MODEL === 'v2' && Object.keys(projectsList).length === 0 && (
                  <p className='project-list-empty'>No projects</p>
                )}
                {DATA_MODEL === 'v2' && canCreateProject(profile) && (
                  <div className='project-list-element-container project-list-new' onClick={() => setNewProjectOpen(true)}>
                    <p style={{ fontSize: '14px', margin: '0px', marginLeft: '10px', color: 'white' }}>+ New project</p>
                  </div>
                )}
            </AccordionDetails>
          </Accordion>
        </div>
        {/* v2 : échantillons de démonstration, ouverts dans le viewer (lecture seule pour qui ne peut pas les modifier). */}
        {DATA_MODEL === 'v2' && demos.length > 0 && (
          <div>
            <Accordion disableGutters defaultExpanded sx = {{width: '250px', backgroundColor: 'black'}}>
              <AccordionSummary expandIcon={<ExpandMore style = {{color:'white'}} />} sx = {accordionSummarySx}>
                <Slideshow className = 'navigation-app-icon' />
                <p style = {{ fontSize:'14px', margin:'0px', marginLeft:'10px', height:'16px'}}>Demos</p>
              </AccordionSummary>
              <AccordionDetails sx = {{padding:'0px'}}>
                {demos.map(demo => {
                  const selected = location.pathname === demoPath(demo);
                  return (
                    <Link key = {demo.id} style = {selected ? {cursor:'default'} : {cursor:'pointer', textDecoration:'none'}} to={demoPath(demo)}>
                      <div className = 'project-list-element-container' style = {selected ? {backgroundColor:'rgb(40,40,40)'} : {}}>
                        <p style = {{ fontSize:'14px', margin:'0px', marginLeft:'10px', color:'white'}}>{demo.name}</p>
                      </div>
                    </Link>
                  );
                })}
              </AccordionDetails>
            </Accordion>
          </div>
        )}
        {/* v2 : pas de demandes d'échantillons ni de réglages pour les comptes externes (vue externe comprise). */}
        {!(DATA_MODEL === 'v2' && profile?.role === 'external') && (
          <>
            <div className='navigation-list-element-container' onClick={() => {handleListElementStyle(3); document.title = 'Sample registration'}}
              style = { isSelected[3] ? {backgroundColor:'rgb(40,40,40)'}:{}}
            >
              <Link style = {isSelected[3] ? {cursor:'default'} : {cursor:'pointer'}} className = 'link-navigation-app-bar' to={ROUTES.NEW_REGISTRATION}>
                <LocalPostOffice className = 'navigation-app-icon' />
                <p>Sample registration</p>
              </Link>
            </div>
            <div className='navigation-list-element-container' onClick={() => {handleListElementStyle(4); document.title = 'Settings'}}
              style = { isSelected[4] ? {backgroundColor:'rgb(40,40,40)'}:{}}
            >
              <Link style = {isSelected[4] ? {cursor:'default'} : {cursor:'pointer'}} className = 'link-navigation-app-bar' to={ROUTES.SETTINGS}>
                <Settings className = 'navigation-app-icon' />
                <p>Settings</p>
              </Link>
            </div>
          </>
        )}
        {profile?.role === 'admin' && (
          <div className='navigation-list-element-container' onClick={() => {handleListElementStyle(5); document.title = 'Administration'}}
            style = { isSelected[5] ? {backgroundColor:'rgb(40,40,40)'}:{}}
          >
            <Link style = {isSelected[5] ? {cursor:'default'} : {cursor:'pointer'}} className = 'link-navigation-app-bar' to={ROUTES.ADMIN}>
              <AdminPanelSettings className = 'navigation-app-icon' />
              <p>Administration</p>
            </Link>
          </div>
        )}
          <div className='navigation-list-element-container' style = {{position:'absolute', bottom:'2%', width:'230px'}} onClick={() => {document.title = 'Signin'}}>
            <SignOutButton />
          </div>
      </div>
      
      <FormDialog
        open={newProjectOpen} title="New project" submitLabel="Create" onClose={() => setNewProjectOpen(false)}
        fields={[{ name: 'name', label: 'Project name', required: true }, { name: 'description', label: 'Description', multiline: true }]}
        onSubmit={async values => { const id = await createProject(profile, values); history.push(ROUTES.FILE_BROWSER + '/' + id); }}
      />
      <div id = 'logo-background-navigation-app-container'> 
        <img id = 'logo-background-navigation-app-bar'  src = {"https://hyprview-landing-images.s3.eu-west-3.amazonaws.com/background-logo.png"} alt = ''/>
      </div>
    </div>
  )
};
const accordionSummarySx = {
  '& .MuiAccordionSummary-content': { display: 'flex', flexDirection: 'row', alignItems: 'center', height: '40px', margin: '0px' },
  backgroundColor: 'black', color: 'white', padding: '0px', border: '0px', boxShadow: 'none', paddingRight: '5px',
  '&:hover': { backgroundColor: 'rgb(40, 40, 40)' },
};

const authCondition = authUser => !!authUser;

export default withAuthorization(authCondition)(NavigationApp);
